import { render, staticRenderFns } from "./SwitchInput.vue?vue&type=template&id=49c3d424&"
import script from "./SwitchInput.vue?vue&type=script&lang=ts&"
export * from "./SwitchInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports